import { HeaderItem } from '@trueprodigy/components';
import React from 'react';
import PropTypes from 'prop-types';

import helpIcon from '../../assets/images/question.svg';
import helpWhiteIcon from '../../assets/images/question-white.svg';

const icons = {
  default: helpIcon,
  white: helpWhiteIcon,
};

const getIcon = color => icons[color];

const HeaderZendeskWidget = ({ color = 'default' }) => (
  <HeaderItem
    icon={getIcon(color)}
    title="Help"
    onClick={() => {
      if (window.zE('webWidget:get', 'display') === 'hidden') {
        window.zE('webWidget', 'show');
        window.zE('webWidget', 'open');
      } else {
        window.zE('webWidget', 'hide');
      }
    }}
  />
);

HeaderZendeskWidget.propTypes = {
  color: PropTypes.string,
};

export default HeaderZendeskWidget;
